import React, { useState } from "react";
import * as S from "./CabImages.styles";
import Icon from "../../../../core-components/IconsSelector";
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";

interface IProps {
  images: Array<string>;
  onIncrementDecrement?: () => {}
}

interface ICabImagesProp {
  t: string;
  img: {}
  info?: string;
  onIncrementDecrement?: () => {}
  onImageTabSelect?: (key : string) => {}
}

const Banner: React.FC<IProps> = ({ images = [], onIncrementDecrement }) => {
  if (!images?.length) return null;
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(images, 2);

  const onIncrementClick = () => {
    if (onIncrementDecrement) onIncrementDecrement()
    increment();
  }

  const onDecrementClick = () => {
    if (onIncrementDecrement) onIncrementDecrement()
    decrement();
  }

  return (
    <S.CarouselSliderWrap>
      <S.CarouselSliderInnerWrap justifyContentProp={images?.length > 2 ? "space-evenly" : "flex-start"}>
        {dataList?.map(
          (item, index) => (
            <li key={index}>
              {item ? <S.SliderImg src={item} alt="offer" /> : null}
            </li>
          )
        ) || null}
      </S.CarouselSliderInnerWrap>
      {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => onIncrementClick()}
          aria-label="Next Image"
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => onDecrementClick()}
          aria-label="Previous Image"
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.CarouselSliderWrap>
  );
};

const CabImagesCarousel: React.FC<ICabImagesProp> = ({ t = '', info = '', img = {}, onIncrementDecrement, onImageTabSelect }) => {
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  if (!t || !(img && Object.keys(img)?.length)) return null;
  return (
    <S.CabImagesContainer>
      <h4 className="font16 fontMedium textDark">{t}</h4>
      {!!info ? <S.InfoContainer>{info}</S.InfoContainer> : null}
      <S.ImageCategoryContainer>
        {Object.keys(img)?.map((key, index) => {
          const selected = !!(key === selectedCategory);
          return (
            <div key={`${key}-${index}`} onClick={() => {
              if(!selected) {
                onImageTabSelect(key)
                setSelectedCategory(key);
              }
            }}>
              <div className={`tab ${selected ? 'activeTab' : ''}`}>{`${key} (${img[key]?.length})`}</div>
              <div className={`${selected ? 'activeBar' : ''}`}></div>
            </div>
          );
        })}
      </S.ImageCategoryContainer>
      <Banner images={img?.[selectedCategory] || []} onIncrementDecrement={onIncrementDecrement}/>
    </S.CabImagesContainer>
  )
}

export default CabImagesCarousel;
